import axios from "axios";
import cookie from "js-cookie";
import router from "@/router";
import { checkStatus } from "./checkStatus";
const afterSaleAxios = axios.create({
  timeout: 10000,
});

afterSaleAxios.interceptors.request.use(
  (config) => {
    if (localStorage.getItem("afterSaleToken")) {
      let token = localStorage.getItem("afterSaleToken");

      config.headers.common.Authorization =
        router.currentRoute.meta.version === "old" ? `Bearer ${token}` : token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

//  响应拦截
afterSaleAxios.interceptors.response.use(
  (res) => {
    if (router.currentRoute.meta.version === "new") {
      if (res?.data?.code.toString().length > 3) {
        checkStatus(res.data.code, res?.data?.message);
        return Promise.reject(res.data);
      }
    }
    return res.data;
  },
  (error) => {
    checkStatus(error?.response?.status);
    return Promise.reject(error);
  }
);

export default {
  login: (params) =>
    afterSaleAxios.post("/api/1/users/signupByPhoneOrEmail", params),
  sendMobileCode: (params) =>
    afterSaleAxios.post("/api/1/users/sendMobileCode", params),
  getSts: () => afterSaleAxios.get("/api/admin/sys/user/sts"),
  getOldSts: () => afterSaleAxios.get("/api/1/config/stss"),

  getBuckets: () => afterSaleAxios.get("/api/1/config/buckets"),
  getDevicesModelList: (params) =>
    afterSaleAxios.get(`/api/1/repos`, {
      params,
    }),
  createWorkorders: (params) =>
    afterSaleAxios.post("/api/1/workorders", params),
  getWorkorders: (params) =>
    afterSaleAxios.post("/api/1/workorders/my/order", params),
  updateWorkorders: (id, params) =>
    afterSaleAxios.put(`/api/1/workorders/${id}`, params),
  getWorkordersDetails: (id) => afterSaleAxios.get(`/api/1/workorders/${id}`),
  delWorkorders: (id) => afterSaleAxios.delete(`/api/1/workorders/${id}`),

  // =========== 新自助售后使用api ===============
  suserLogin: (params) => afterSaleAxios.post("/api/suser/login", params),
  getProductList: () => afterSaleAxios.get(`/api/product/list`),
  createRepairReq: (params) =>
    afterSaleAxios.post(`/api/repairReq/add`, params),
  getRepairReqList: (params) =>
    afterSaleAxios.get(`/api/repairReq/myWithToken`, { params }),
  updateRepairWithUser: (params) =>
    afterSaleAxios.post(`/api/repairReq/updateWithUser`, params),
  getRepairReqDetails: (params) =>
    afterSaleAxios.get(`/api/repairReq/infoWithUserToken`, { params }),
  updateDocStatus: (params) =>
    afterSaleAxios.post(`/api/repairReq/destoryWithUserToken`, params),
  delRepair: (params) =>
    afterSaleAxios.post("/api/repairReq/delMyRepairReq", params),
  // getRepairReqInfo: (params) =>
  //   afterSaleAxios.get(`/api/repairReq/info`, { params }),
  getArealist: (params) => afterSaleAxios.post(`/api/kuaidi/addrlist`, params),
  getFittinglist: (params) =>
    afterSaleAxios.get(`/api/fitting/list`, { params }),
  getWechatOpenId: (params) =>
    afterSaleAxios.get(`/api/admin/sys/user/getWechatOpenId`, { params }),
  newSendMobileCode: (params) =>
    afterSaleAxios.post("/api/suser/sendMobileCode", params),
  orderPay: (params) => afterSaleAxios.post("/api/order/add", params),
  getPdfExport: (params) =>
    afterSaleAxios.post("/api/repair/pdfExport", params),
  getRepairPolicy: () => afterSaleAxios.get("/api/repairPolicy/one"),
  getEventNotif: (params) =>
    afterSaleAxios.get("/api/client/function-controller/matched", { params }),
  getPayConfig: (params) =>
    afterSaleAxios.get("/api/paypal/config", { params }),
  createPayOrder: (params) =>
    afterSaleAxios.post("/api/order/add-by-paypal", params),
  payCapture: (params) =>
    afterSaleAxios.post("/api/order/paypal/capture", params),
  getTicket: (params) => afterSaleAxios.post("/api/bwy/invoice/issue", params),
};
